import config from '../config';
import Slider from './slider';
import { throttle } from '../utils';

const { breakpoints } = config;
const $win = $(window);

export default class StocksSlider extends Slider {
    constructor() {
        const settings = {
            node: $('.js-stocks-slider'),
            fade: false,
            dots: false,
            variableWidth: true,
            infinite: false,
            autoplay: false,
            responsive: []
            // responsive: [
            //     {
            //         breakpoint: 9999999,
            //         settings: 'unslick'
            //     },
            //     {
            //         breakpoint: breakpoints.md,
            //         settings: {
            //             slidesToShow: 1,
            //             slidesToScroll: 1,
            //         }
            //     }
            // ]
        };

        super(settings);

        this.init();
    }

    _windowResizeHandler = throttle(() => {
        if ($(window).width() > breakpoints.md) {
            if (this.$sliderContainer.hasClass('slick-initialized')) {
                this.$sliderContainer.slick('unslick');
            }
            return
        }

        if (!this.$sliderContainer.hasClass('slick-initialized')) {
            return this.$sliderContainer.slick(this.options);
        }
    }, 300);

    init() {
        super.init();

        $win.on('load', this._windowResizeHandler);
        $win.on('resize', this._windowResizeHandler);
    }
}



// WEBPACK FOOTER //
// ./components/stocksSlider.js